import React, { Component } from 'react'
import Overlay from 'react-bootstrap/Overlay'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

 class UserValidation extends Component {
    constructor(props){
        super(); 
        this.state ={
            selfie:'Dosya Yükle'
        }
        this.handleImageChange = this.handleImageChange.bind(this);
    }
    handleImageChange(e) {
        let file = e.target.files[0];;
        e.preventDefault();
        console.log(file.name);
        this.setState({
            selfie:file.name
        })
    }
    renderTooltip(props) {
        return <Tooltip {...props}>Buraya yakisikli bi fotograf yukle</Tooltip>;
    }
    back  = (e) => {
        e.preventDefault();
        this.props.prevStep();
    }
    next = (e) => {
        e.preventDefault();
        this.props.nextStep();
    }
    render() {
        const questionHead=this.props.questionHead;
        console.log(questionHead);
        const Input = React.createRef();
        return (
            <div className="validationContainer">
                <div className="backContainer">
                    <input type="submit" value="Geri" onClick={this.back} className="backButton"/>
                </div>
                <div className="formArea">
                    <div className="formHead">
                        <span>Konu Basligi</span>    
                        <p>{questionHead}</p>
                    </div>
                    <div className="formRow">
                        <div className="formColumn">
                            <label htmlFor="name">Ad</label>
                            <input type="text" id="name" placeholder="Adinizi giriniz"/>
                        </div>
                        <div className="formColumn surnameMobile">
                            <label htmlFor="soyad">Soyad</label>
                            <input type="text" id="surname" placeholder="Soyadinizi giriniz"/>
                        </div>
                    </div>
                    <div className="formRow">
                        <div className="formColumn columnOne">
                            <label htmlFor="tckn">TCKN</label>
                            <input type="text" id="tckn" placeholder="11 haneli TC Kimlik No'nuzu giriniz"/>
                        </div>
                    </div>
                    <div className="formRow">
                        <div className="formColumn">
                            
                            <label>
                            <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderTooltip}
                            >
                                <img src={require('../images/info.svg')} className="selfieInfo hidden" />
                                </OverlayTrigger>   
                                Selfie
                                <OverlayTrigger
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderTooltip}
                            >
                                <img src={require('../images/info.svg')} className="selfieInfo selfieShow"/>
                                </OverlayTrigger> 
                            </label>
                            <label htmlFor="selfie" onClick={ () => { Input.current.click(); } } className="selfie">{this.state.selfie}</label>
                        <input
                            hidden
                            type='file'
                            name='selfie'
                            accept='image/png, image/jpeg'
                            ref={ Input }
                            onChange={ this.handleImageChange }
                        />

                        </div>
                        <div className="formColumn">
                            
                        </div>
                    </div>
                    <div className="formRow noBorder">
                        <input type="submit" className="formSubmit" onClick={this.next} value="DEVAM"/>
                    </div>
                    <div className="notice">
                Bu bölümde giriş yaptığınız kişisel bilgileriniz <img 
                                        src={require('../images/qnb_logo.png')} 
                                        srcSet={`
                                            ${require('../images/qnb_logo@2x.png')} 2x, 
                                            ${require('../images/qnb_logo@3x.png')} 3x, 
                                        `}
                                        />  tarafından korunmaktadır. Üçüncü kişi ve kurumlara paylaşılmaz.
                    </div>
                </div>
                
            </div>
        )
    }
}
export default UserValidation